import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { BehaviorSubject, Observable, catchError,  switchMap, take, throwError } from 'rxjs';
// import { AuthService } from 'src/app/auth/auth.service';
import { AuthService } from '../../auth/service/auth.service';
// import { AuthService } from '../../services/auth.services';
import { SKIP_INTERCEPTOR } from './http-context.tokens';
import { TokenService } from '../services/token.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<unknown> = new BehaviorSubject<unknown>(null);

  constructor(private authService:AuthService, private tokenService:TokenService) {}

  intercept(request: HttpRequest<string>, next: HttpHandler): Observable<HttpEvent<string>> {

    if (request.context.get(SKIP_INTERCEPTOR)) {
      return next.handle(request); // ✅ Skip the interceptor
    }

    // const token = localStorage.getItem('JWT_TOKEN');
    const token = this.tokenService.getJwtToken();

    // // Authentication Interceptor:add authentication tokens or headers to every outgoing HTTP request.
    if(token){
      request = this.addToken(request, token);
      // console.log(request);
    // send cloned request with header to the next handler.
      // return next.handle(request);
    }
    // Error Handling Interceptor
    return next.handle(request).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        return this.handle401Error(request, next);
      }
      else {
        return throwError(()=>error);
      }
    }));
    // return next.handle(request);
  }
  // handle error:
  private handle401Error(request: HttpRequest<string>, next: HttpHandler) {
    const refresh_token: any = this.tokenService.getRefreshToken();

    if (!this.isRefreshing) {
      this.isRefreshing = true;
      // Set the refreshTokenSubject to null so that subsequent API calls will wait until the new token has been retrieved
      this.refreshTokenSubject.next(null);
      return this.authService.refreshAccessToken(refresh_token).pipe(
        switchMap((token: any) => {
          this.isRefreshing = false;
          this.tokenService.storeTokens(token);
          // localStorage.setItem('JWT_TOKEN', token.access_token);
          this.refreshTokenSubject.next(token.access_token);
          return next.handle(this.addToken(request, token.access_token));
        }),
      );
    }  else {
      return this.refreshTokenSubject.pipe(
        // If isRefreshing is true, we will wait until refreshTokenSubject has a non-null value
        // which means the new token is ready and we can retry the request again
        take(1),
        switchMap((jwt) => {
           // Refresh token failed, navigate to login
          if(jwt == null){
            this.authService.logout();
          }
          return next.handle(this.addToken(request, jwt));
          // this.authService.logout();
        })
      );
    }
  }

  private addToken(request: HttpRequest<string>, token: unknown) {

    const token_type = this.tokenService.getTokenType();
    // Clone the request and replace the original headers with cloned headers, updated with the authorization.
    return request.clone({
      setHeaders: {
        'Authorization': `${token_type} ${token}`
      }
    });
  }
}
